import { Button, Checkbox, Flex, Input, Select, Table, TableContainer, Tbody, Text, Th, Thead, Tr } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { useMutation, useQuery } from 'react-query'
import { AcompanhamentoItem } from './AcompanhamentoItem'
import { format } from 'date-fns'
import { api } from '../../../services/api'
import { formatPrice } from '../../../utils/formatPrice'
import { useEffect, useState } from 'react'
import Axios from 'axios'
import { useForm } from 'react-hook-form'

async function getListDiscount(data_entrada, data_saida, aprovacao) {
  const response = await api.post(`/site/v2/pedido/listar-informacoes-desconto`, {
    data_entrada,
    data_saida,
    aprovacao,
  })

  response.data.sort((a, b) => {
    if (a.nome_usuario_desconto < b.nome_usuario_desconto) {
      return -1
    }
    if (a.nome_usuario_desconto > b.nome_usuario_desconto) {
      return 1
    }
    return 0
  })

  return response.data.map((item) => {
    return {
      data: item.data_solicitacao ? format(new Date(item?.data_solicitacao), 'dd/MM/yyyy HH:mm') : '',
      funcionario: item?.nome_usuario_desconto?.toLowerCase(),
      codigo_produto: item?.codigo_produto,
      produto: item?.descricao_produto?.toLowerCase(),
      quantidade: item?.pecas_danificadas,
      observacao: item?.observacao ? item?.observacao?.substring(0, 10).concat('...') : '',
      originalObservacao: item?.observacao,
      id_usuario: item?.id,
      valor_desconto: formatPrice(item?.valor_desconto),
      numero_pedido: item?.ad_numinno,
      referencia: item?.referencia,
    }
  })
}

export function AcompanhamentoVale() {
  const initialDateMonth = new Date()
  initialDateMonth.setDate(1)
  const finalDateMonth = new Date()
  finalDateMonth.setDate(30)

  const { handleSubmit, register } = useForm()

  const { data, mutateAsync } = useMutation((data) => getListDiscount(data.data_entrada, data.data_saida, data.aprovacao))

  const [loading, setLoading] = useState(false)

  async function generateExcel() {
    if (!data) return
    if (data.length === 0) return

    setLoading(true)

    const header = ['Data', 'Numero do Pedido', 'Funcionário', 'Cod. Prod', 'Produto', 'Referência', 'Quantidade Perda', 'Motivo', 'Valor desconto']

    const dataItems = data?.map((item) => {
      return {
        data: item.data,
        numero_pedido: item.numero_pedido,
        funcionario: item.funcionario,
        codigo_produto: item.codigo_produto,
        produto: item.produto,
        referencia: item.referencia,
        quantidade: item.quantidade,
        observacao: item.observacao,
        valor_desconto: item.valor_desconto,
      }
    })

    try {
      const response = await Axios.post(
        'https://apihomolog.innovationbrindes.com.br/node/transform-to-excel',
        {
          header: header,
          data: dataItems,
        },
        { responseType: 'arraybuffer' }
      )

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${new Date()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.log(error)
      setLoading(false)
    }

    setLoading(false)
  }

  async function handleSearch(data) {
    try {
      await mutateAsync(data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const date = new Date()
    const mesAtual = date.getMonth() + 1
    const anoAtual = date.getFullYear()
    const dayAtual = date.getDate()

    const data_entrada = `${anoAtual}-${mesAtual < 10 ? `0${mesAtual}` : mesAtual}-01`
    const data_saida = `${anoAtual}-${mesAtual < 10 ? `0${mesAtual}` : mesAtual}-${dayAtual}`

    handleSearch({
      data_entrada: data_entrada,
      data_saida: data_saida,
      aprovacao: 'N',
    })
  }, [])

  return (
    <>
      <HeadingPages name="Acompanhamento Vale" />

      <Layout>
        <Flex alignItems="center" justifyContent="center" gap={2} w="full" mx="auto" maxW="700px">
          <label>De:</label>
          <Input type="date" {...register('data_entrada')} />
          <label>Até:</label>
          <Input type="date" {...register('data_saida')} />

          <Select {...register('aprovacao')}>
            <option value="">Todos</option>
            <option value="S">Aprovado</option>
            <option value="N">Não Aprovado</option>
          </Select>

          <Button colorScheme="green" onClick={handleSubmit(handleSearch)} maxW="100px" w="full">
            Buscar
          </Button>
        </Flex>

        {data?.length > 0 && (
          <Text fontSize="sm" color="gray.500" mb={2}>
            Exibindo {data?.length} registros
          </Text>
        )}
        <Button colorScheme="green" onClick={generateExcel} loadingText="Gerando Excel..." isLoading={loading} disabled={data?.length === 0}>
          Gerar Excel
        </Button>

        <TableContainer
          w="full"
          mt="1rem"
          size="sm"
          maxH={window.innerHeight - 300}
          overflowY="scroll"
          boxShadow="md"
          borderRadius="md"
          border="1px solid #e2e8f0"
        >
          <Table variant="simple">
            <Thead position="sticky" top="0" bg="#E2E8F0" zIndex={10}>
              <Tr>
                <Th>Data</Th>
                <Th>Numero do Pedido</Th>
                <Th>Funcionário</Th>
                <Th>Cod. Prod</Th>
                <Th>Produto</Th>
                <Th>Referência</Th>
                <Th textAlign="center">Quantidade Perda</Th>
                <Th textAlign="center">Motivo</Th>
                <Th textAlign="center">Valor desconto</Th>
                <Th textAlign="center">Aprovar</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data?.map((item, index) => (
                <AcompanhamentoItem
                  key={index}
                  item={item}
                  refresh={() =>
                    handleSearch({
                      data_entrada: '',
                      data_saida: '',
                      aprovacao: 'N',
                    })
                  }
                />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Layout>
    </>
  )
}
